export default (value) => {
  const phone = value.replace(/[^\d]/g, '')
  if (phone.length === 10)
    return phone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
  else
    return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
}
